import {
    SandboxState,
    SET_OUTCOME_GOAL,
    SET_CLIENT,
    SET_AUTO_MODE,
    SandboxTypes,
    SET_PATIENT,
    RESET_SANDBOX,
    UPDATE_AUTO_STATUS,
    SET_BODY_PART_NUM,
    OPEN_TRANSCRIPT,
} from './sandboxTypes';

const initialState: SandboxState = {
    patient: {
        first_name: '',
        last_name: '',
        patient_id: '',
        referral_type: {},
        dob: '',
    },
    client: undefined,
    autoMode: false,
    outcomeGoal: 'F2F',
    playInAutoMode: false,
    autoBodyParts: 1,
    openTranscript: false,
};

export default function sandboxReducer(
    state = initialState,
    action: SandboxTypes,
): SandboxState {
    switch (action.type) {
        case SET_PATIENT: {
            return {
                ...state,
                patient: action.payload,
            };
        }

        case SET_CLIENT: {
            return {
                ...state,
                client: action.payload,
            };
        }

        case SET_OUTCOME_GOAL: {
            return {
                ...state,
                outcomeGoal: action.payload,
            };
        }
        case SET_AUTO_MODE: {
            return {
                ...state,
                autoMode: action.payload,
                playInAutoMode: false,
            };
        }
        case UPDATE_AUTO_STATUS: {
            return {
                ...state,
                playInAutoMode: action.payload,
            };
        }
        case SET_BODY_PART_NUM: {
            return {
                ...state,
                autoBodyParts: action.payload,
            };
        }
        case OPEN_TRANSCRIPT: {
            return {
                ...state,
                openTranscript: action.payload,
            };
        }
        case RESET_SANDBOX: {
            return {
                ...state,
                patient: {
                    first_name: '',
                    last_name: '',
                    patient_id: '',
                    referral_type: {},
                    dob: '',
                },
                client: undefined,
                autoMode: false,
                outcomeGoal: '',
            };
        }
        default: {
            return state;
        }
    }
}
